import InlineTabs from 'components/commons/inline-tabs'
import { UserSummary } from 'components/user/user-detail/UserSummary'
import { useSelector } from 'react-redux'

export const UserDetail = ({ dataTabs, activeTab, setActiveTabHandler, content, isLoading }) => {
    const { userDetails } = useSelector((state) => state.userReducer)

    return (
        <div className={'flex flex-col space-y-3'}>
            <div className={'flex flex-col space-y-6'}>
                <div className={'flex flex-col px-9 py-4'}>
                    {userDetails?.statistic && (
                        <UserSummary dataSummary={userDetails?.statistic} isLoading={isLoading} />
                    )}
                </div>
                <InlineTabs options={dataTabs} onChange={setActiveTabHandler} activeTab={activeTab} />
            </div>
            {content[activeTab]}
        </div>
    )
}
